var map = {
	"./Boguslawa Piela.webp": 173,
	"./Justyna Ferensowicz.webp": 174,
	"./Marcin Cnota.webp": 175,
	"./Marcin Sidorowicz.webp": 176,
	"./Marzena Malec.webp": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;